import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { TbExternalLink, TbLink } from 'react-icons/tb';
import { useSearchParams } from 'react-router-dom';

import mrhLogo from '@/assets/images/primary-for-restaurants.webp';

import iconSent from '../../../assets/images/email-sent.gif';
import { Typography } from '@/components/atoms/Typography';
import { Button } from '@/components/molecules/Button';
import { LoginForm } from '@/components/organisms/LoginForm';
import { LoginLayout } from '@/components/templates/LoginLayout';

export const LoginPage = (): JSX.Element => {
  const { t } = useTranslation();
  const [isLinkSent, setIsLinkSent] = useState(false);
  const [searchParams] = useSearchParams();
  const authError = searchParams.get('authError');

  useEffect(() => {
    if (authError === 'true') {
      setTimeout(() => {
        toast.error(t('authentication.genericAuthError', "Erreur d'authentification, veuillez réessayer."), {
          position: 'bottom-right',
          duration: 8000
        });
      }, 100);
    }
  }, [authError, t]);

  const onLoginSuccess = () => {
    setIsLinkSent(true);
    toast.success(t('action.loginMailSent'), {
      position: 'bottom-right',
      duration: 8000
    });
  };

  return (
    <LoginLayout isLinkSent={isLinkSent}>
      <div
        className={classNames(
          isLinkSent ? 'w-full' : 'xl:fixed xl:inset-y-10',
          'sm:mx-auto relative flex gap-20 px-5 xl:px-24 flex-col justify-between xl:items-start items-center xl:py-10 bg-white xl:mx-auto'
        )}
      >
        {isLinkSent ? (
          <div className="flex flex-col gap-6 text-center border p-3 md:p-6 rounded-2xl">
            <div>
              <img src={iconSent} draggable={false} alt="icon sent" className="w-full h-40 object-contain" />
              <h2 className="text-[#FB7C20] font-bold text-2xl mt-4">Un e-mail est en route !</h2>
            </div>
            <Typography variant="h4">
              Un lien magique a <strong>été envoyé</strong> à votre adresse e-mail <strong>associée à votre restaurant</strong>.
            </Typography>
            <Typography variant="h4">Il vous permettra d'accéder directement à vos informations et de gérer votre fiche restaurant.</Typography>

            <Typography variant="h2" weight="bold">
              Vérifiez votre boîte e-mail
            </Typography>

            <Button onClick={() => setIsLinkSent(false)} type="button" color="gray" label="Saisir un autre e-mail" fullWidth />
          </div>
        ) : (
          <>
            <img width={200} height={100} src={mrhLogo} alt="logo of mrh" className="h-fit w-42 md:w-80 object-contain" />
            <LoginForm onSuccess={onLoginSuccess} />
          </>
        )}

        <span className=" gap-2 flex flex-col items-center text-center">
          <p className="text-xs">Espace réservé aux restaurateurs / Franchises / gérants de restaurant / équipes de communication & marketing</p>
          <a href="https://mon-resto-halal.com" className="flex items-center justify-center w-fit hover:underline space-x-1 text-xs">
            <TbExternalLink />
            <p>mon-resto-halal.com</p>
          </a>
        </span>
      </div>
    </LoginLayout>
  );
};
